<div class="page-content-wrapper apps-wrapper">
  <div class="page-content-wrapper-header">
    <div>
      <div class="heading">{{'SIDEBAR.INTEGRATIONS' | translate}}</div>
    </div>
  </div>
  <div class="section-wrapper mb-0 flex-fill">
    <div class="section-content-wrapper">
      <div class="apps-catalog" *ngIf="!selectedApp else appDetails;">
        <!-- Search with embedded Filters trigger (ENG-2249), mirrors the conversation inbox -->
        <div class="apps-search-row">
          <div class="search-input-wrapper" [class.active]="isSearchActive" ngbDropdown placement="bottom-right"
            autoClose="outside" container="body" #filtersDropdown="ngbDropdown">
            <span class="filters-anchor" ngbDropdownAnchor></span>
            <ng-icon class="search-icon" name="heroMagnifyingGlass"></ng-icon>
            <input type="text" class="search-input" [formControl]="searchControl"
              [placeholder]="'APPS.SEARCH_PLACEHOLDER' | translate" [dataHook]="'apps-search'">
            <button *ngIf="isSearchActive" type="button" class="search-clear" (click)="clearSearch()"
              [attr.aria-label]="'APPS.CLEAR_SEARCH' | translate">
              <ng-icon name="heroXMark"></ng-icon>
            </button>
            <div class="search-filter-divider"></div>
            <button type="button" class="search-filter-trigger" [class.has-active]="hasAdvancedFilters"
              ngbDropdownToggle [dataHook]="'apps-filters'" [attr.aria-label]="'APPS.FILTERS' | translate">
              <ng-icon name="heroAdjustmentsHorizontal"></ng-icon>
              <span class="filter-badge" *ngIf="advancedFilterCount">{{ advancedFilterCount }}</span>
            </button>

            <div ngbDropdownMenu class="apps-filters-panel">
              <div class="filters-panel-header">
                <span class="panel-title">{{ 'APPS.FILTERS' | translate }}</span>
              </div>

              <div class="filters-panel-body">
                <div class="filter-group" *ngIf="categoryOptions.length">
                  <div class="filter-group-label">{{ 'APPS.FILTER_TYPE' | translate }}</div>
                  <div class="type-options d-flex flex-wrap gap-2">
                    <button type="button" class="type-pill" *ngFor="let category of categoryOptions; trackBy: trackCategory"
                      [class.selected]="isCategorySelected(category.key)" (click)="toggleCategory(category.key)"
                      [dataHook]="'filter-category-' + category.key">
                      <ng-icon class="check" name="heroCheck" *ngIf="isCategorySelected(category.key)"></ng-icon>
                      {{ category.label }}
                    </button>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="filter-group-label">{{ 'APPS.FILTER_STATUS' | translate }}</div>
                  <div class="type-options d-flex flex-wrap gap-2">
                    <button type="button" class="type-pill" [class.selected]="connectedOnly"
                      (click)="toggleConnectedOnly()" [dataHook]="'filter-status-connected'">
                      <ng-icon class="check" name="heroCheck" *ngIf="connectedOnly"></ng-icon>
                      {{ 'APPS.STATUS_CONNECTED' | translate }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Filters apply live; Reset clears them, Apply confirms and closes. -->
              <div class="filters-panel-footer">
                <rosie-button class="footer-btn" [customClass]="'secondary slimmer text-sm'" [translationKey]="'APPS.RESET'"
                  (click)="clearAdvancedFilters()" [dataHook]="'apps-filters-reset'"></rosie-button>
                <rosie-button class="footer-btn" [customClass]="'slimmer text-sm'" [translationKey]="'APPS.APPLY'"
                  (click)="filtersDropdown.close()" [dataHook]="'apps-filters-apply'"></rosie-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Active filter chips -->
        <div class="active-filter-chips d-flex align-items-center flex-wrap gap-2" *ngIf="filterChips.length">
          <span class="filter-chip" *ngFor="let chip of filterChips; trackBy: trackFilterChip" [dataHook]="'apps-filter-chip-' + chip.id">
            <span class="chip-label">{{ chip.translate ? (chip.label | translate) : chip.label }}</span>
            <button type="button" class="chip-remove" (click)="removeChip(chip.id)"
              [attr.aria-label]="'APPS.REMOVE_FILTER' | translate">
              <span class="chip-x" aria-hidden="true">✕</span>
            </button>
          </span>
          <button type="button" class="chips-clear-all" (click)="clearAllFilters()" [dataHook]="'apps-filters-clear-all'">
            {{ 'APPS.CLEAR_ALL' | translate }}
          </button>
        </div>

        <!-- Grouped catalog -->
        <div class="app-groups" *ngIf="hasResults; else noResults">
          <section class="app-group" *ngFor="let group of appGroups; trackBy: trackGroup" [dataHook]="'apps-group-' + group.key">
            <h2 class="app-group-title">{{ group.label }}</h2>
            <div class="d-flex app-list justify-content-center justify-content-md-start gap-4">
              <div (click)="seeApp(app.key)" *ngFor="let app of group.apps; trackBy: trackApp" [dataHook]="'apps-name-' + app.name"
                class="app-item">
                <div class="logo-wrapper position-relative">
                  <img [src]="getLogo(app)">
                </div>
                <div class="app-details">
                  <div class="title-wrapper">
                    <div class="title">{{ app.name }}</div>
                    <div *ngIf="getAppStatus(app)" class="status-badge" [ngClass]="getAppStatus(app)">
                      <img [src]="'assets/images/'+getAppStatus(app)+'-icon.svg'"
                        *ngIf="app?.status !== AppStatus.ComingSoon">{{
                      getAppStatusCopy(app) }}
                    </div>
                  </div>
                  <div class="description">{{ app.description }}</div>
                </div>
                <rosie-button [customClass]="'secondary narrow slimmish text-sm'" [translationKey]="'Add New Integration'"
                  class="add-new-integration-button" *ngIf="app.key === AppKey.OtherSchedulingTools"
                  (click)="requestNewIntegration($event)"
                  [iconPrefixConfig]="{name: 'heroPlusCircle', size: '20px', strokeWidth: '2', color: '#9487A0'}"></rosie-button>
              </div>
            </div>
          </section>
        </div>

        <ng-template #noResults>
          <div class="apps-empty-state" [dataHook]="'apps-no-results'">
            <div class="empty-title">{{ (hasAnyActiveFilters ? 'APPS.NO_RESULTS' : 'APPS.NONE_AVAILABLE') | translate }}</div>
            <div class="empty-description">
              {{ (hasAnyActiveFilters ? 'APPS.NO_RESULTS_DESCRIPTION' : 'APPS.NONE_AVAILABLE_DESCRIPTION') | translate }}
            </div>
            <button type="button" class="empty-clear" *ngIf="hasAnyActiveFilters" (click)="clearAllFilters()">
              {{ 'APPS.CLEAR_ALL' | translate }}
            </button>
          </div>
        </ng-template>

        <!-- ENG-2278: the button is the Intercom custom launcher for the request-integration workflow -->
        <div class="request-integration-banner" [dataHook]="'apps-request-integration-banner'">
          <img class="banner-icon" src="assets/images/request-integration-icon.svg" alt="" aria-hidden="true">
          <div class="banner-text">
            <div class="banner-title">{{ 'APPS.REQUEST_BANNER.TITLE' | translate }}</div>
            <div class="banner-description">{{ 'APPS.REQUEST_BANNER.DESCRIPTION' | translate }}</div>
          </div>
          <rosie-button class="banner-button request-integration-intercom-trigger" [customClass]="'transparent'"
            [customType]="'button'" [fullWidth]="false" [translationKey]="'APPS.REQUEST_BANNER.BUTTON'">
            <!-- Figma's arrow is not the heroicons one; projected content renders before the label, so CSS orders it after -->
            <img class="banner-button-arrow" src="assets/images/request-integration-arrow.svg" alt="" aria-hidden="true">
          </rosie-button>
        </div>
      </div>
    </div>
  </div>
  <ng-template #appDetails>
    <div (click)="seeApp('')" [dataHook]="'APPS.BACK'" class="d-flex align-items-center pointer back">
      <div class="icon"><ng-icon [name]="'heroArrowUturnLeft'" [color]="'black'"></ng-icon></div>
      <span>{{ 'APPS.BACK' | translate }}</span>
    </div>
    <rosie-app [app]="selectedApp"></rosie-app>
  </ng-template>
</div>
<div class="request-integration-intercom-trigger rosie-invisible"></div>
